import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './ui/card';

const AnimatedBorderCard = ({ children, onClick, className = '' }) => {
  const uniqueId = `border-${Math.random().toString(36).substr(2, 9)}`; // Unique ID to prevent conflicts
  
  return (
    <motion.div
      whileHover={{ y: -2, scale: 1.005 }}
      whileTap={{ scale: 0.995 }}
      className={`relative cursor-pointer ${className}`}
      onClick={onClick}
      style={{ padding: '2px' }}
    >
      {/* SVG overlay for animated border */}
      <div className="absolute inset-0 overflow-visible" style={{ zIndex: 100, pointerEvents: 'none' }}>
        <svg 
          width="100%" 
          height="100%" 
          style={{ 
            position: 'absolute',
            top: 0,
            left: 0,
            overflow: 'visible'
          }}
        >
          <defs>
            <filter id={`glow-${uniqueId}`}>
              <feGaussianBlur stdDeviation="3" result="blur"/>
              <feMerge>
                <feMergeNode in="blur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
            <filter id={`glow-strong-${uniqueId}`}>
              <feGaussianBlur stdDeviation="6" result="blur"/>
              <feMerge>
                <feMergeNode in="blur"/>
                <feMergeNode in="blur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          
          {/* Outer glow layer */}
          <rect
            x="2"
            y="2"
            width="calc(100% - 4px)"
            height="calc(100% - 4px)"
            rx="12"
            fill="none"
            stroke="rgba(0, 220, 240, 0.7)"
            strokeWidth="3"
            strokeLinecap="round"
            filter={`url(#glow-strong-${uniqueId})`}
            strokeDasharray="100, 1100"
          >
            <animate
              attributeName="stroke-dashoffset"
              from="1200"
              to="0"
              dur="20s"
              repeatCount="indefinite"
            />
          </rect>
          
          {/* Core bright line */}
          <rect
            x="2"
            y="2"
            width="calc(100% - 4px)"
            height="calc(100% - 4px)"
            rx="12"
            fill="none"
            stroke="rgba(0, 240, 255, 1)"
            strokeWidth="2"
            strokeLinecap="round"
            filter={`url(#glow-${uniqueId})`}
            strokeDasharray="80, 1120"
          >
            <animate
              attributeName="stroke-dashoffset"
              from="1200"
              to="0"
              dur="20s"
              repeatCount="indefinite"
            />
          </rect>
        </svg>
      </div>
      
      {/* Card Content */}
      <Card className="border-0 shadow-lg relative group">
        <div className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl" />
        <CardContent className="p-6 relative">
          {children}
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default AnimatedBorderCard;
